import componentIconMap from '../../Shared/componentIconMap.json';

export function getIcon(type) {
    return componentIconMap[type];
}